"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _trackBackButtonClick = require("./trackBackButtonClick");
Object.keys(_trackBackButtonClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _trackBackButtonClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trackBackButtonClick[key];
    }
  });
});
var _trackNextButtonClick = require("./trackNextButtonClick");
Object.keys(_trackNextButtonClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _trackNextButtonClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trackNextButtonClick[key];
    }
  });
});